import React from "react";
import "./LegalNotice.css";

function LegalNotice() {
  return (
    <div className="LegalNotice">
      <p className="LegalNoticeTitle">Legal notice :</p>

      <p className="LegalNoticeText">
        Please read carefully the different terms of use of this site before
        browsing its pages. By connecting to this site, you unreservedly accept
        these terms. Also, in accordance with article n ° 6 of Law n ° 2004-575
        of June 21, 2004 on confidence in the digital economy, the managers of
        this website are :
      </p>

      <p className="LegalNoticeTitle">Terms of use :</p>

      <p className="LegalNoticeText">
        This site is available in different web languages ​​(HTML, HTML5,
        Javascript, CSS, etc…) for better user comfort and more pleasant
        graphics, we recommend that you use modern browsers such as Internet
        Explorer, Safari, Firefox, Google Chrome, etc… The agency uses all the
        means at its disposal to ensure reliable information and reliable
        updating of its websites. However, errors or omissions may occur. The
        user must therefore ensure the accuracy of the information from, and
        report any changes to the site that he deems useful. is in no way
        responsible for the use made of this information, and for any direct or
        indirect damage that may result. Cookies: The site may ask you to accept
        cookies for statistical and display purposes. A cookie is information
        placed on your hard drive by the server of the site you are visiting. It
        contains several pieces of data that are stored on your computer in a
        simple text file that a server accesses to read and save information.
        Some parts of this site may not be functional without the acceptance of
        cookies. Hypertext links: The websites of may provide links to other
        websites or other resources available on the Internet. has no means of
        controlling sites in connection with its websites. does not answer for
        the availability of such sites and external sources, nor does it
        guarantee it. It cannot be held responsible for any damage of any nature
        whatsoever resulting from the content of these sites or external
        sources, and in particular from the information, products or services
        they offer, or from any use that may be made of these elements. The
        risks associated with this use fall fully on the Internet user, who must
        comply with their conditions of use. Users, subscribers and visitors to
        websites cannot set up a hyperlink to this site without the express
        prior authorization of In the event that a user or visitor wishes to set
        up a hyperlink to this site one of the websites of, it will be up to him
        to send an email accessible on the site in order to formulate his
        request for the establishment of a hyperlink. reserves the right to
        accept or refuse a hyperlink without having to justify its decision.
      </p>

      <p className="LegalNoticeTitle">Contractual limitation on data :</p>

      <p className="LegalNoticeText">
        This site is available in different web languages ​​(HTML, HTML5,
        Javascript, CSS, etc…) for a better comfort of use and a more pleasant
        graphics, we recommend you to use modern browsers such as Internet
        Explorer, Safari, Firefox, Google Chrome, etc. The agency implements all
        the means at its disposal to ensure reliable information and reliable
        updating of its websites. However, errors or omissions may occur. The
        user must therefore ensure the accuracy of the information from, and
        report any changes to the site that he deems useful. is in no way
        responsible for the use made of this information, and for any direct or
        indirect damage that may result. Cookies: The site may ask you to accept
        cookies for statistical and display purposes. A cookie is information
        placed on your hard drive by the server of the site you are visiting. It
        contains several pieces of data that are stored on your computer in a
        simple text file that a server accesses to read and save information.
        Some parts of this site may not be functional without the acceptance of
        cookies. Hypertext links:The information on this site is as accurate as
        possible and the site is updated at different times of the year, but may
        contain inaccuracies or omissions. If you notice a gap, error or what
        appears to be a malfunction, please report it by email to the address,
        describing the problem in the most appropriate way. precise possible
        (page causing the problem, type of computer and browser used, etc.). All
        downloaded content is done at the user's own risk and under his sole
        responsibility. Consequently, cannot be held responsible for any damage
        to the user's computer or any loss of data resulting from the download.
        In addition, the user of the site agrees to access the site using recent
        equipment, which does not contain viruses and with an up-to-date latest
        generation browser. The hypertext links set up within the framework of
        this website to other resources present on the Internet can not engage
        our responsibility.
      </p>

      <p className="LegalNoticeTitle">Intellectual property :</p>

      <p className="LegalNoticeText">
        All the content of this site, including, without limitation, graphics,
        images, texts, videos, animations, sounds, logos, gifs and icons as well
        as their formatting are the exclusive property of the company with the
        exception of trademarks, logos or content belonging to other partner
        companies or authors. Any reproduction, distribution, modification,
        adaptation, retransmission or publication, even partial, of these
        different elements is strictly prohibited without the express written
        consent of this representation or reproduction, by any means whatsoever
        either, constitutes an infringement punishable by articles L.335-2 and
        following of the Code of the intellectual property. Failure to comply
        with this prohibition constitutes an infringement which may engage the
        civil and criminal liability of the infringer. In addition, the owners
        of the copied Content could take legal action against you.
      </p>

      <p className="LegalNoticeTitle">Declaration to the CNIL :</p>

      <p className="LegalNoticeText">
        The information on this site is as accurate as possible and the site is
        updated at different times of the year, but may contain inaccuracies or
        omissions. If you notice a gap, error or what appears to be a
        malfunction, please report it by email to the address, describing the
        problem as precisely as possible (page causing the problem, type of
        computer and browser used,…). All downloaded content is done at the
        user's own risk and under his sole responsibility. Consequently, cannot
        be held responsible for any damage to the user's computer or any loss of
        data resulting from the download. In addition, the user of the site
        agrees to access the site using recent equipment, which does not contain
        viruses and with an up-to-date latest generation browser. The hypertext
        links set up within the framework of this website to other resources
        present on the Internet network can not engage our responsibility.
      </p>

      <p className="LegalNoticeTitle">Disputes :</p>

      <p className="LegalNoticeText">
        All the content of this site, including, without limitation, graphics,
        images, texts, videos, animations, sounds, logos, gifs and icons as well
        as their formatting are the exclusive property of the company with the
        exception of brands, logos or content belonging to other partner
        companies or authors. Any reproduction, distribution, modification,
        adaptation, retransmission or publication, even partial, of these
        different elements is strictly prohibited without the express written
        consent of This representation or reproduction, by any means whatsoever,
        constitutes an infringement punishable by the articles. L.335-2 and
        following of the Code of intellectual property. Failure to comply with
        this prohibition constitutes an infringement which may engage the civil
        and criminal liability of the infringer. In addition, the owners of the
        copied Content could take legal action against you.
      </p>

      <p className="LegalNoticeTitle">Personnal data :</p>

      <p className="LegalNoticeText">
        In accordance with Law 78-17 of January 6, 1978 (amended by Law 2004-801
        of August 6, 2004 relating to the protection of individuals with regard
        to the processing of personal data) relating to computers, files and
        freedoms, this site has been declared 1656629 to the National Commission
        for Informatics and Freedoms (www.cnil.fr).
      </p>
    </div>
  );
}

export default LegalNotice;
